"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _progress = _interopRequireDefault(require("./progress.png"));
var _Mediator = _interopRequireDefault(require("./Mediator"));
var _Settings = _interopRequireDefault(require("./Settings"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = {
  handle: 'progress',
  label: 'Top Bar',
  thumbnail: _progress["default"],
  settingsComponent: _Settings["default"],
  mediatorComponent: _Mediator["default"]
};